module.exports = __webpack_public_path__ + "img/Oman_logo_ramadan_ar.f5425d64.jpg";